export const BRAND       = "#EF4277";
export const BRAND_LIGHT = "#FDE8EF";
export const BRAND_DARK  = "#BE1E53";

export const FIELD_OPTIONS = [
  { key: "desiredJobTitle", label: "Desired Job Title" },
  { key: "location",        label: "Location"          },
  { key: "desiredSalary",   label: "Desired Salary"    },
  { key: "summary",         label: "Summary"           },
  { key: "skills",          label: "Skills"            },
  { key: "recruiterName",     label: "Recruiter Name"     },
  { key: "recruiterEmail",    label: "Recruiter Email"    },
  { key: "recruiterMobile",   label: "Recruiter Mobile"   },
  { key: "recruiterPhone",    label: "Recruiter Phone"    },
  { key: "recruiterJobTitle", label: "Recruiter Job Title" },
  { key: "button",          label: "Email Button"      }
];

export const SEARCH_BY_OPTIONS = [
  { key: "candidateName",   label: "Name",        placeholder: "Search by name…"     },
  { key: "jobTitle",        label: "Job Title",   placeholder: "Search by job title…" },
  { key: "emailAddress",    label: "Email",       placeholder: "Search by email…"     },
  { key: "candidateId",     label: "ID",          placeholder: "Enter candidate ID…"  },
  { key: "currentEmployer", label: "Employer",    placeholder: "Search by employer…"  }
];

export const DATA_FILTER_OPTIONS = [
  { key: "hasRecruiter", label: "Has Recruiter" },
  { key: "hasSalary",    label: "Has Salary"    },
  { key: "hasSkills",    label: "Has Skills"    },
  { key: "hasSummary",   label: "Has Summary"   }
];
